

import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { isDefined, isEmptyString } from "../helpers";

export function requiredWithCustomMessage(value = "required", key = "required"): ValidatorFn {
  return (control: AbstractControl) => {
    if (isEmptyString(control.value)) {
      //2 lines below are needed since its imposible to make a direct asigment  aka  return {key:value}
      const retVal: { [key: string]: unknown } = {};
      retVal[key] = value;
      return retVal;
    }
    return null;
  };
}

export function setError(destination: AbstractControl, key: string, value: unknown) {
  const errors: ValidationErrors = destination.errors ?? {};
  errors[key] = value;
  destination.setErrors({ ...errors });
}

export function removeError(destination: AbstractControl, key: string) {
  const errors: ValidationErrors = destination.errors ?? {};
  if (isDefined(errors[key])) {
    delete errors[key];
    if (Object.keys(errors).length === 0) {
      destination.setErrors(null);
    } else {
      destination.setErrors({ ...errors });
    }
  }
}

/* eslint-disable  @typescript-eslint/no-explicit-any */
export type ControlsOf<T extends Record<string, any>> = {
  [K in keyof T]: T[K] extends Record<any, any>
  ? FormGroup<ControlsOf<T[K]>>
  : FormControl<T[K]>;
};
